/**
 * @file This file provides utility functions for handling storage-related operations, such as parsing storage IDs.
 */

/**
 * Utility functions for handling storage-related operations
 */

/**
 * Extracts bucketKey and objectKey from a storage ID
 * @param {string} storageId - The storage ID in format "os.object:bucketKey/objectKey"
 * @returns {Object} An object containing bucketKey and objectKey
 * @throws {Error} If the storageId format is invalid
 */
export const extractBucketAndObjectKeys = (storageId) => {
    if (!storageId || typeof storageId !== 'string') {
        throw new Error('Invalid storageId: must be a non-empty string');
    }

    if (!storageId.includes('os.object:')) {
        throw new Error('Invalid storageId format: must contain "os.object:" prefix');
    }

    const bucketObject = storageId.split("os.object:")[1];
    
    if (!bucketObject) {
        throw new Error('Invalid storageId format: missing bucket/object information after "os.object:"');
    }

    const parts = bucketObject.split("/");
    
    if (parts.length < 2) {
        throw new Error('Invalid storageId format: must contain both bucketKey and objectKey separated by "/"');
    }

    const [bucketKey, ...objectKeyParts] = parts;
    const objectKey = objectKeyParts.join("/"); // Handle object keys that might contain additional slashes

    return {
        bucketKey,
        objectKey
    };
};